/* Progressive layout enhancement for Wokiee. Native forms, prices, stock and
   app nodes are retained. Product descriptions remain visible without JS. */
(() => {
  'use strict';
  if (window.agProductPageDesign) return;
  window.agProductPageDesign = true;
  const roots = '.product-page-template > section[id^="MainProduct-"]';
  const direct = (parent, selector) => Array.from(parent.children).find(el => el.matches(selector));
  function enhance(root) {
    if (root.dataset.agDesignReady === 'true') return;
    const grid = root.querySelector('.main-product__container');
    const info = root.querySelector('[id^="ProductInfo-"]');
    if (!grid || !info) return;
    root.dataset.agDesignReady = 'true';
    const price = direct(info, '.product__price-container');
    let priceAnchor = price;
    Array.from(info.children).forEach(el => {
      if (!el.matches('.shopify-block')) return;
      const signature = (el.id + ' ' + el.className + ' ' + (el.getAttribute('data-block-handle') || '')).toLowerCase();
      if (priceAnchor && /omnibus|price.history|price-history/.test(signature)) {
        el.classList.add('ag-price-history');
        priceAnchor.after(el);
        priceAnchor = el;
      }
    });
    const buy = direct(info, '.product__buttons');
    const benefits = Array.from(info.children).find(el => el.querySelector('.product__blurbs__container'));
    if (buy && benefits) {
      benefits.classList.add('ag-product-benefits');
      buy.after(benefits);
    }
    const description = direct(info, '.product-tab:not(.product-tab-secondary)');
    const rows = Array.from(info.children).filter(el => el.matches('.product-tab-secondary'));
    if (!description && !rows.length) return;
    const details = document.createElement('div');
    details.className = 'ag-product-details';
    grid.after(details);
    if (description) {
      const body = direct(description, '.product-tab__content');
      if (body) {
        const section = document.createElement('section');
        section.className = 'ag-product-description';
        section.id = 'ag-description-' + root.dataset.section;
        const heading = document.createElement('h2');
        heading.className = 'ag-product-description__heading';
        heading.id = section.id + '-heading';
        heading.textContent = 'Opis produktu';
        section.setAttribute('aria-labelledby', heading.id);
        const editor = description.getAttribute('data-shopify-editor-block');
        if (editor) section.setAttribute('data-shopify-editor-block', editor);
        body.className = 'ag-product-description__body';
        body.style.removeProperty('height');
        body.style.removeProperty('--height');
        section.append(heading, body);
        details.append(section);
        description.remove();

      }
    }
    if (rows.length) {
      const extra = document.createElement('div');
      extra.className = 'ag-product-extra';
      rows.forEach(row => {
        const title = row.querySelector('.product-tab__heading__text');
        const content = direct(row, '.product-tab__content');
        if (!title || !content) return;
        const disclosure = document.createElement('details');
        disclosure.className = 'ag-product-disclosure';
        const summary = document.createElement('summary');
        summary.textContent = title.textContent.trim();
        disclosure.open = row.classList.contains('opened');
        const editor = row.getAttribute('data-shopify-editor-block');
        if (editor) disclosure.setAttribute('data-shopify-editor-block', editor);
        content.className = 'ag-product-disclosure__content';
        content.style.removeProperty('height');
        content.style.removeProperty('--height');
        disclosure.append(summary, content);
        extra.append(disclosure);
        row.remove();
      });
      if (extra.children.length) details.append(extra);
    }
    if (!details.children.length) details.remove();
  }
  function boot(scope = document) {
    if (scope.matches && scope.matches(roots)) enhance(scope);
    scope.querySelectorAll(roots).forEach(enhance);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => boot(), {once:true});
  else boot();
  document.addEventListener('shopify:section:load', event => boot(event.target));
})();
